var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Snack'),_c('testSnackbar'),_c('router-view'),(_vm.loading)?_c('preloader'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }